/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Partner } from "./partner.type";
import { PartnerTableService } from "./partner-table.service";
import { UserInfo } from "../../../shared/types/user-info";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { AuthenticationService } from "../../../core/authentication/authentication.service";

@Component({
  selector: "app-partners",
  templateUrl: "./partner.component.html",
  styleUrls: ["./partner.component.scss"],
})
export class PartnersComponent implements OnInit {
  currentUser: UserInfo;
  tableConfig: DataTable<Partner>;

  constructor(
    public partnerTableService: PartnerTableService,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  // #region Lifecycle Methods

  ngOnInit(): void {
    this.tableConfig = this.partnerTableService.getPartnersTableConfig();
  }

  // #endregion

  // #region Handlers

  onAddPartner(): void {
    this.addPartner();
  }

  // #endregion

  // #region Private Methods

  private addPartner(): void {
    this.router.navigate(["/partners/create"]);
  }

  // #endregion
}
